import { ListItem, ListItemProps, styled } from '@material-ui/core';

type ButtonListItemProps = ListItemProps<'div', { button: true }>;

const DefaultListItem = ({
  button,
  ...props
}: ListItemProps | ButtonListItemProps) => (
  <ListItem
    ContainerComponent="div"
    // MUI v4 ListItem overloads require literal `true` for button but ListItemProps
    // unions boolean, causing a mismatch (https://github.com/mui/material-ui/issues/14971).
    {...(props as ButtonListItemProps)}
    button={button as true}
  />
);

export const SelectListItem = styled(DefaultListItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  paddingRight: 0,
  gap: theme.spacing(1),
}));
